import { render, staticRenderFns } from "./Folgas.vue?vue&type=template&id=e95ec8fa"
import script from "./Folgas.vue?vue&type=script&lang=js"
export * from "./Folgas.vue?vue&type=script&lang=js"
import style0 from "./Folgas.vue?vue&type=style&index=0&id=e95ec8fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports